import type { HexMapState } from '../../engine/render/renderer';
import type { AbstractModal } from '../../modal/AbstractModal';

export function getActiveModal(state: HexMapState): AbstractModal | null {
    if (!state.activeModalId) return null;
    return state.modals.find((modal) => modal.id === state.activeModalId) || null;
}

export function getActiveJobsTabId(state: HexMapState): string | null {
    const modal = getActiveModal(state);
    if (!modal) return null;
    const anyModal = modal as { activeJobsTabId?: string | null };
    return anyModal.activeJobsTabId ?? null;
}

export function getActiveBuildingsTabId(state: HexMapState): string | null {
    const modal = getActiveModal(state);
    if (!modal) return null;
    const anyModal = modal as { activeBuildingsTabId?: string | null };
    return anyModal.activeBuildingsTabId ?? null;
}

export function getEnemyTileId(state: HexMapState, fallback: string): string {
    const entry = Object.values(state.enemyForces).find((enemy) => !enemy.defeatedAt);
    return entry?.tileId || fallback;
}

export function getNearestSettlementId(
    state: HexMapState,
    _tileId: string,
    fallback: string,
): string {
    const settlements = Object.values(state.settlementsById);
    return settlements[0]?.id || fallback;
}
